// extracted by mini-css-extract-plugin
export default {"form":"PageDataInputs_form__w76EU","section-data":"PageDataInputs_section-data__qs7og","div-button":"PageDataInputs_div-button__ar4N1"};